import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import {
  COCHARGE_DARK_GREEN,
  COCHRAGE_DARK_GREEN_RGBA,
  INDIGO_COLOR,
  PURPLE_COLOR,
  TEAL_COLOR,
  ORANGE_COLOR,
  TEXT_COLOR,
  TEXT_COLOR_SECONDARY,
  SURFACE_BORDER,
} from "../../../../styles/theme_constants";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend
);

export const CHART_COLORS = {
  primary: COCHARGE_DARK_GREEN,
  primaryLight: COCHRAGE_DARK_GREEN_RGBA(0.15),
  lime: "#C3E76B",
  limeLight: "rgba(195, 231, 107, 0.3)",
  orange: ORANGE_COLOR,
  orangeLight: "rgba(245, 124, 0, 0.15)",
  indigo: INDIGO_COLOR,
  purple: PURPLE_COLOR,
  teal: TEAL_COLOR,
  gray: "#94a3b8",
};

export const PROVIDER_COLORS = [
  COCHARGE_DARK_GREEN,
  "#C3E76B",
  ORANGE_COLOR,
  INDIGO_COLOR,
  PURPLE_COLOR,
  TEAL_COLOR,
  "#ec4899",
  "#14b8a6",
];

export const CHART_FONT = {
  family: "var(--font-family)",
  size: 12,
};

export const formatNumber = (value: number, decimals = 2): string => {
  return value.toLocaleString("en", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const sharedChartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  animation: { duration: 300 },
  plugins: {
    legend: {
      labels: {
        font: CHART_FONT,
        color: TEXT_COLOR,
        usePointStyle: true,
        pointStyle: "circle",
        boxWidth: 8,
        boxHeight: 8,
        padding: 16,
      },
    },
    tooltip: {
      backgroundColor: COCHARGE_DARK_GREEN,
      titleFont: { ...CHART_FONT, weight: "bold" as const },
      bodyFont: CHART_FONT,
      cornerRadius: 8,
      padding: 10,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { font: CHART_FONT, color: TEXT_COLOR_SECONDARY },
    },
    y: {
      grid: { color: SURFACE_BORDER },
      ticks: { font: CHART_FONT, color: TEXT_COLOR_SECONDARY },
    },
  },
};
